/**
 * Inline SVG glyphs used by the nav rail and the mobile tab bar. Inline (rather than an icon font
 * or sprite file) so they inherit `currentColor` and stay available offline with zero extra
 * requests. All are drawn on a 24×24 grid with stroke-based geometry — `.icon` in styles.css sets
 * fill/stroke.
 */
export type IconName = 'chat' | 'files' | 'pipeline' | 'benchmarks' | 'account' | 'folder' | 'github' | 'commit';

const PATHS: Record<IconName, string> = {
  chat: '<path d="M4 5.5h16v11H9.5L5.5 20v-3.5H4z"/>',
  files: '<path d="M4 6.2A1.2 1.2 0 0 1 5.2 5h3.6l1.8 2.2h8.2A1.2 1.2 0 0 1 20 8.4v9.4a1.2 1.2 0 0 1-1.2 1.2H5.2A1.2 1.2 0 0 1 4 17.8z"/>',
  pipeline: '<path d="M4 7.5h4M14 7.5h6M4 16.5h10M18 16.5h2"/><circle cx="11" cy="7.5" r="2.6"/><circle cx="16" cy="16.5" r="2.6"/>',
  benchmarks: '<path d="M4 19.5h16"/><path d="M6.8 19.5V12M12 19.5V6.5M17.2 19.5v-5"/>',
  account: '<circle cx="12" cy="8.6" r="3.6"/><path d="M5.4 19.4a6.6 6.6 0 0 1 13.2 0"/>',
  folder: '<path d="M4 6.2A1.2 1.2 0 0 1 5.2 5h3.6l1.8 2.2h8.2A1.2 1.2 0 0 1 20 8.4v9.4a1.2 1.2 0 0 1-1.2 1.2H5.2A1.2 1.2 0 0 1 4 17.8z"/>',
  github:
    '<path d="M9.2 20.2v-2.6c-3 .6-3.7-1.4-3.7-1.4-.5-1.2-1.2-1.6-1.2-1.6-1-.7.1-.7.1-.7 1.1.1 1.7 1.1 1.7 1.1 1 1.7 2.6 1.2 3.2.9.1-.7.4-1.2.7-1.5-2.4-.3-4.9-1.2-4.9-5.3 0-1.2.4-2.1 1.1-2.9-.1-.3-.5-1.4.1-2.9 0 0 .9-.3 3 1.1a10 10 0 0 1 5.4 0c2.1-1.4 3-1.1 3-1.1.6 1.5.2 2.6.1 2.9.7.8 1.1 1.7 1.1 2.9 0 4.1-2.5 5-4.9 5.3.4.4.8 1.1.8 2.2v3.3"/>',
  commit: '<circle cx="12" cy="12" r="3.4"/><path d="M4 12h4.6M15.4 12H20"/>',
};

export function icon(name: IconName): string {
  return `<svg class="icon" viewBox="0 0 24 24" aria-hidden="true">${PATHS[name]}</svg>`;
}
